<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import { cloneDeep, groupBy } from "lodash";
import RequestItemCard from "@/router/views/procurement/settings-template/request-item-card.vue";
import ReturnModal from "@/components/modals/return-item-request.vue";
import Swal from "sweetalert2";
import UpdateItemRequest from "@/components/modals/update-item-request.vue";
import ItemCategory from "@/components/modals/item-category-with-personnels.vue";
import Unit from "@/components/modals/unit.vue";
import ItemLogs from "@/components/modals/item-request-logs.vue";

export default {
    page: {
        title: "Item Request(s)",
    },
    components: {
        Layout,
        PageHeader,
        RequestItemCard,
        ReturnModal,
        UpdateItemRequest,
        ItemCategory,
        Unit,
        ItemLogs
    },
    data() {
        return {
            title: "Item Request(s)",
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Item Request(s)",
                    active: true,
                },
            ],
            pendingItemBusy: false,
            pendingItems: [],
            approvedItems: [],
            approveItemBusy: false,
            itemRow: null,
            myProfile: null,
            activeTab: 0,
        };
    },
    async created() {
        this.pendingItemBusy = true;
        await this.getProfile();
        await this.getPendingData(this.$store.state.data.selectedCampus.id);
        this.pendingItemBusy = false;
    },
    methods: {
        async getProfile(){
            await this.$store
                .dispatch("account/GetProfile")
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    console.log(res.data)
                    this.myProfile = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async getPendingData(campusId) {
            await this.$store
                .dispatch("itemrequest/GetCampusPendingItemRequest", campusId)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    var groups = [];
                    var grouped = groupBy(res.data, "deliveryUnitId");
                    for (var key in grouped) {
                        var filterKey = "";
                        grouped[key].map(item => {
                            filterKey += ` ${item.itemName} ${item.description}`
                            item.filterKey = `${item.itemName} ${item.description}`;
                        })
                        groups.push({
                            deliveryUnitId: key,
                            name: grouped[key][0].deliveryUnit,
                            count: grouped[key].length,
                            showDetails: false,
                            items: grouped[key],
                            filterKey: filterKey
                        });
                    }
                    this.pendingItems = groups;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        returnItem(item, type){
            this.returnType = type;
            this.$refs.returnModal.returnData(item);
            this.itemRow = cloneDeep(item)
            this.$bvModal.show('return-modal');
        },
        async returnItemSubmission(modalData) {
            let remarks = [];
            let data = cloneDeep(modalData);
            if(this.itemRow.returnRemarks){
                remarks = JSON.parse(this.itemRow.returnRemarks);
            }
            remarks.push({
                remarks: data.remarks,
                date: this.getDate(new Date()),
                user: this.myProfile ? `${this.myProfile.completeName}(${this.myProfile.deliveryUnit})` : "Unknown",
            });
            let newData = { id: data.id, remarks: JSON.stringify(remarks)}
            await this.$store
                .dispatch("itemrequest/ReturnItemRequest", newData)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    if(this.returnType == 'pending'){
                        let parentIndex = this.pendingItems.findIndex(x => x.deliveryUnitId == this.itemRow.deliveryUnitId);
                        let index = this.pendingItems[parentIndex].items.findIndex(x => x.id == this.itemRow.id);
                        this.pendingItems[parentIndex].items.splice(index, 1);
                        if(this.pendingItems[parentIndex].items.length == 0){
                            this.pendingItems.splice(parentIndex, 1);
                        }
                    }else{
                        let parentIndex = this.approvedItems.findIndex(x => x.deliveryUnitId == this.itemRow.deliveryUnitId);
                        let index = this.approvedItems[parentIndex].items.findIndex(x => x.id == this.itemRow.id);
                        this.approvedItems[parentIndex].items.splice(index, 1);
                        if(this.approvedItems[parentIndex].items.length == 0){
                            this.approvedItems.splice(parentIndex, 1);
                        }
                    }
                    this.$bvModal.hide('return-modal');
                    this.showToast("Successfully returned", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async changeCampus(id) {
            if(this.activeTab == 0){
                this.pendingItemBusy = true;
                await this.getPendingData(id);
                this.pendingItemBusy = false;
            }else{
                this.approveItemBusy = true;
                await this.getApprovedData(id);
                this.approveItemBusy = false;
            }
        },
        async viewPending(){
            this.pendingItemBusy = true;
            await this.getPendingData(this.$store.state.data.selectedCampus.id);
            this.pendingItemBusy = false;
        },
        async viewApproved(){
            this.approveItemBusy = true;
            await this.getApprovedData(this.$store.state.data.selectedCampus.id);
            this.approveItemBusy = false;
        },
        async getApprovedData(id){
            await this.$store
                .dispatch("itemrequest/GetCampusApprovedItemRequest", id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    var groups = [];
                    var grouped = groupBy(res.data, "deliveryUnitId");
                    for (var key in grouped) {
                        var filterKey = "";
                        grouped[key].map(item => {
                            filterKey += ` ${item.itemName} ${item.description}`
                            item.filterKey = `${item.itemName} ${item.description}`;
                        })
                        groups.push({
                            deliveryUnitId: key,
                            name: grouped[key][0].deliveryUnit,
                            count: grouped[key].length,
                            showDetails: false,
                            items: grouped[key],
                            filterKey: filterKey
                        });
                    }
                    this.approvedItems = groups;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        approveItem(item){
            Swal.fire({
                title: "Are you sure?",
                text: "You want to approve this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, approve it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("itemrequest/ApproveItemRequest", item.id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let parentIndex = this.pendingItems.findIndex(x => x.deliveryUnitId == item.deliveryUnitId);
                            let index = this.pendingItems[parentIndex].items.findIndex(x => x.id == item.id);
                            this.pendingItems[parentIndex].items.splice(index, 1);
                            if(this.pendingItems[parentIndex].items.length == 0){
                                this.pendingItems.splice(parentIndex, 1);
                            }
                            this.showToast("Successfully approved", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        updateItemRequest(modalData){
            var data = cloneDeep(modalData);
            data.unitCost = this.getExactAmt(modalData.unitCost);
            data.departmentId = data.departmentId || 0;
            this.$store
                .dispatch("itemrequest/UpdateItemRequest", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(
                            res.data.errorMessage,
                            "error"
                        );
                    }
                    let parentIndex = this.pendingItems.findIndex(x => x.deliveryUnitId == data.deliveryUnitId);
                    let index = this.pendingItems[parentIndex].items.findIndex(x => x.id == data.id);
                    this.pendingItems[parentIndex].items.splice(index, 1, data);
                    this.showToast("Successfully updated!", "success");
                    this.$bvModal.hide('item-update-modal');
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong! - updating item",
                        "error"
                    );
                });
            this.submitted = false;
        },
        updateRequest(item){
            this.$refs.updateForm.putData(item);
            this.$bvModal.show('item-update-modal');
        },
        getUnit() {
            this.$refs.unit.getData();
            this.$bvModal.show("unit-modal");
        },
        dropUnit(data) {
            this.$refs.updateForm.dropUnit(data);
        },
        getItemCategory() {
            this.$bvModal.show("item-category-modal");
        },
        dropItemCat(data) {
            this.$refs.updateForm.dropItemCat(data);
        },
        viewLog(item){
            console.log(item)
            var logs = JSON.parse(item.returnRemarks);
            if(logs){
                logs.map(item => {
                    item.dateWTime = this.formatDateWithTime(
                        new Date(item.date)
                    );
                    item.splitted = item.dateWTime.split(" at ");
                })
            }
            this.$refs.itemLogs.getData(logs);
            this.$bvModal.show('item-request-logs-modal');
        }
    }
};
</script>
<template>
  <Layout @changeCampus="changeCampus($event.id)">
        <PageHeader :title="title" :items="items" />
        <b-tabs content-class="mt-4" nav-class="nav-tabs-custom" v-model="activeTab">
            <b-tab @click="viewPending">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Pending Requests</span>
                </template>
                <RequestItemCard 
                    :items="pendingItems" 
                    :busy="pendingItemBusy" 
                    :withActions="true" 
                    @returnItem="returnItem($event, 'pending')"
                    @approveItem="approveItem"
                    @updateItem="updateRequest"
                    @viewLog="viewLog"
                />
            </b-tab>
            <b-tab @click="viewApproved">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Approved Requests</span>
                </template>
                <RequestItemCard 
                    :items="approvedItems" 
                    :busy="approveItemBusy" 
                    :withActions="$store.state.decrypt.isAdmin()"
                    @viewLog="viewLog"
                    @returnItem="returnItem($event, 'approved')"
                    @approveItem="approveItem"
                    @updateItem="updateRequest"
                />
            </b-tab>
        </b-tabs>
        <ReturnModal ref="returnModal" @returnItem="returnItemSubmission" />
        <item-category @dropData="dropItemCat($event)"></item-category>
        <unit ref="unit" @dropData="dropUnit($event)"></unit>
        <UpdateItemRequest 
            ref="updateForm" 
            @updateItemRequest="updateItemRequest" 
            @getUnit="getUnit"
            @getItemCategory="getItemCategory"
        />
        <item-logs ref="itemLogs"></item-logs>
  </Layout>
</template>